export default __webpack_public_path__ + "static/media/Quiken_Solucion_Almacenamiento-10.df5f6477.svg";